<div>
  <a [href]="privatePolicy" target="_blank" rel="noopener noreferrer" class="logo">
    {{applicationName}}
    <span></span>
  </a>
  <br />
  <p class="mb-0">
    Copyright © 2022 {{companyName}}
    <a [href]="privatePolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
  </p>
</div>